import React from 'react';
import { brandInfo } from '../data/mockData';
import UmrahEnquiryForm from './UmrahEnquiryForm';

const Hero = ({ onOpenBuilder, onSearch }) => {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center pt-24 pb-16"
      style={{
        backgroundImage: `url('https://images.pexels.com/photos/2895295/pexels-photo-2895295.jpeg?auto=compress&cs=tinysrgb&w=1920')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/50"></div>

      {/* Content */}
      <div className="relative z-10 w-full px-4">
        <div className="text-center text-white max-w-4xl mx-auto mb-8">
          {/* Badge */}
          <div className="inline-block bg-[#d4af37] text-black px-4 py-1 rounded-full text-sm font-semibold mb-4">
            Your Trusted Umrah Partner
          </div>

          <h1 className="font-serif mb-3">
            <span 
              className="block text-4xl md:text-6xl lg:text-7xl italic text-[#d4af37] mb-1"
              style={{ fontFamily: 'Playfair Display, Georgia, serif', fontStyle: 'italic' }}
            >
              ZamZam
            </span>
            <span 
              className="block text-2xl md:text-4xl lg:text-5xl font-light tracking-wider"
              style={{ fontFamily: 'Playfair Display, Georgia, serif' }}
            >
              Umrah
            </span>
          </h1>

          <p className="text-base md:text-lg text-gray-200 mb-6 max-w-2xl mx-auto">
            Cheapest Umrah Online. Submit your enquiry and our team will prepare your personalised package.
          </p>
        </div>

        {/* Inline Umrah Enquiry Form */}
        <UmrahEnquiryForm />

        {/* Trust Indicators */}
        <div className="mt-8 flex flex-wrap justify-center gap-8 text-sm text-white">
          <div className="flex items-center gap-2">
            <span className="w-8 h-8 bg-[#d4af37] rounded-full flex items-center justify-center">
              <svg className="w-4 h-4 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </span>
            <span>ATOL Protected</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-8 h-8 bg-[#d4af37] rounded-full flex items-center justify-center">
              <svg className="w-4 h-4 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </span>
            <span>10,000+ Pilgrims Served</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-8 h-8 bg-[#d4af37] rounded-full flex items-center justify-center">
              <svg className="w-4 h-4 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </span>
            <span>24/7 Pilgrim Support</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2">
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
